/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { FeaturesPlaceNameListDto } from '../../models/features-place-name-list-dto';

export interface GetPlaceNameListById$Params {
  featureId: number;
}

export function getPlaceNameListById(
  http: HttpClient,
  rootUrl: string,
  params: GetPlaceNameListById$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<FeaturesPlaceNameListDto>> {
  const rb = new RequestBuilder(rootUrl, getPlaceNameListById.PATH, 'get');
  if (params) {
    rb.path('featureId', params.featureId, {});
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<FeaturesPlaceNameListDto>;
      }),
    );
}

getPlaceNameListById.PATH = '/features/{featureId}/names';
